import { styled } from '@mui/material/styles';

const StyledHr = styled('hr')(
  ({ theme }) => `
    width: 100%;
    margin: ${theme.spacing(['sm'])} 0;
    border-color: ${theme.palette.border.black};

    ${theme.breakpoints.up('tablet')} {
      margin: ${theme.spacing(['lg'])} 0;
    }
  `,
);

export { StyledHr };
